import { FC } from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export const Twitter: FC<IconProps> = ({
  fill = "none",
  height = "3rem",
  viewBox = "0 0 54 54",
  width = "3rem",
  ...props
}) => (
  <Icon fill={fill} height={height} viewBox={viewBox} width={width} {...props}>
    <path
      d="M16.9819 48.9391C37.3594 48.9391 48.505 32.0565 48.505 17.4161C48.505 16.9365 48.505 16.4592 48.4726 15.984C50.6408 14.4156 52.5125 12.4737 54 10.2492C51.9781 11.1456 49.8331 11.7332 47.6366 11.9923C49.9496 10.6078 51.6806 8.43005 52.5074 5.86437C50.3327 7.15499 47.9534 8.06448 45.4723 8.55357C43.8019 6.77737 41.5927 5.60121 39.1864 5.20711C36.7802 4.813 34.3112 5.22293 32.1614 6.37344C30.0117 7.52395 28.301 9.35091 27.2942 11.5716C26.2873 13.7923 26.0405 16.2829 26.5918 18.6581C22.187 18.4371 17.878 17.2924 13.9443 15.2982C10.0106 13.304 6.54022 10.5049 3.7584 7.08261C2.34164 9.5216 1.90771 12.4089 2.54497 15.1566C3.18224 17.9043 4.84277 20.3058 7.18848 21.8721C5.42527 21.8205 3.70046 21.3448 2.16 20.4854V20.6258C2.1607 23.1837 3.04616 25.6627 4.66621 27.6421C6.28625 29.6216 8.54114 30.9798 11.0484 31.4863C9.41733 31.9312 7.70597 31.9962 6.04584 31.6764C6.75408 33.8776 8.13246 35.8025 9.98829 37.182C11.8441 38.5615 14.0846 39.3266 16.3966 39.3703C14.0995 41.1759 11.469 42.5108 8.65547 43.2988C5.84198 44.0868 2.90073 44.3123 0 43.9625C5.06662 47.2137 10.9618 48.9384 16.9819 48.9305"
      fill="currentColor"
    />
  </Icon>
);
